/**
 * Created by WorkAxis www.workaxis.in
 * Developer: Padma Dev.E
 * Developer Contact: padmadev.e@workaxis.in
 * Admin: shyam@workaxis.in
 * Date: 19/08/22
 * Time: 9:22 PM
 * Project: smallcal
 */
import React, { useEffect, useMemo, useRef, useState } from "react";
import "../style.css";
import Refresh from "../../../icon/Refresh";
import { useDispatch, useSelector } from "react-redux";
import { syncNow } from "../../../redux/sync/syncReducer";
import { logoutApi, authState } from "../../../redux/auth/authReducer";
import User from "../../../icon/User";
import UserGroup from "../../../icon/UserGroup";
import LogoutIcon from "../../../icon/LogoutIcon";
import { useNavigate } from "react-router-dom";
import {
    URL_ANALYTICS,
    URL_INTEGRATION,
    URL_ORGANIZATION,
    URL_PRICING,
    URL_PROFILE,
    URL_SUBSCRIPTION,
    URL_CREDITS,
    URL_API_MANAGEMENT,
    URL_SUPPORT,
} from "../../../routes/url";
import { getActiveRouteConfig, getConfiguredRoutes } from "../../../routes/routesConfig";
import CreditCardIcon from "../../../icon/CreditCardIcon";
import CodeBracketIcon from "../../../icon/CodeBracketIcon";
import Cash from "../../../icon/Cash";
import BuildingOffice from "../../../icon/BuildingOffice";
import { profileState } from "../../../redux/profile/profileReducer";
import AuthAccountSwitcher from "../../../component/AuthAccountSwitcher/AuthAccountSwitcher";
import { AccountSwitcher } from "../../../component/AccountSwitcher/AccountSwitcher";

import {
    TOP_NAV_DROPDOWN_ORG_SUBSCRIPTION,
    TOP_NAV_DROPDOWN_CREDITS,
    TOP_NAV_VIEW_MODE_SWITCHER,
    TOP_NAV_DROPDOWN_API_MANAGEMENT,
    SUPPORT_PAGE,
} from "../../../component/Check/PrivilegeConstants";
import { PrivilegeCheck } from "../../../component/Check/PrivilegeCheck";
import ChevronDown from "../../../icon/ChevronDown";
import ChevronUp from "../../../icon/ChevronUp";
import { isCULActionAllowed, isPlanAllowed, isPrivilegeAllowed } from "../../../utils/PrivilegeControl/PrivilegeControl";
import { enterprisePlan, ownerRole, adminRole, memberRole } from "../../../utils/constants";
import { WhatsappResetState } from "../../../redux/Integration/whatsappReducer";
import IntegrationIcon from "../../../icon/Integration";
import ArrowTrendingUpIcon from "../../../icon/ArrowTrendingUpIcon";
import GridDotsIcon from "../../../icon/GridDotsIcon";
import { useBrand } from "../../../context/BrandContext";
import CoinsIcon from "../../../icon/CoinsIcon";

export default function TopNavigation({
    mobileNavExpand, mobileNavCallback = null,
}) {
    const [profileFall, setProfileFall] = useState(false);
    const brand = useBrand();

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { profile, viewingAs } = useSelector(profileState);
    const { isAuthenticated } = useSelector(authState);

    const [allowItems, setAllowItems] = useState(isCULActionAllowed())
    const isEnterpriseAndOwner = isPlanAllowed([enterprisePlan]) && isPrivilegeAllowed([ownerRole])
    useEffect(() => {
        setAllowItems(isCULActionAllowed())
    }, [profile.data, viewingAs.data, dispatch]);

    // Merged partner + profile route_config (profile overrides win per route)
    const activeRouteConfig = useMemo(
        () =>
            getActiveRouteConfig({
                isAuthenticated: Boolean(isAuthenticated || profile?.data),
                profileRouteConfig: profile?.data?.route_config,
                brandRouteConfig: brand?.route_config,
            }),
        [brand?.route_config, isAuthenticated, profile?.data?.route_config]
    );
    const configuredPrivateRoutes = useMemo(
        () => getConfiguredRoutes(activeRouteConfig).private || [],
        [activeRouteConfig]
    );
    const isPrivateRouteEnabled = (routeId) =>
        configuredPrivateRoutes.some((route) => route.id === routeId);

    const hidePricingOrg = (process.env.REACT_APP_HIDE_PRICING || "")
        .split(",")
        .includes(profile?.data?.userorgrolemapping?.organization?.id);


    const brandLogo = useMemo(() => {
        const tempLogo = profile?.data?.userorgrolemapping?.organization?.profile_pic
        if (tempLogo) {
            // return {
            //     mobile: tempLogo,
            //     pc: tempLogo
            // }
            return {
                mobile: brand?.logo_mobile,
                pc: brand?.logo_pc
            }
        } else {
            return {
                mobile: brand?.logo_mobile,
                pc: brand?.logo_pc
            }
        }
    }, [profile.data, brand]);

    const Logout = () => {
        dispatch(logoutApi());
    };

    const [syncCSS, setSyncCSS] = useState("w-1-5");

    const sync = () => {
        dispatch(WhatsappResetState())
        dispatch(syncNow(Date.now()));
        setSyncCSS((old) => `${old} rotate`);
        setTimeout(function () {
            setSyncCSS((old) => old.replace("rotate", ""));
        }, 2000);
    };
    const profileFallRef = useRef(null);

    // Handler defined inside effect so add/remove share the same reference (avoids stale listeners)
    useEffect(() => {
        if (!profileFall) return;

        const onOutsideClick = (e) => {
            if (
                profileFallRef.current &&
                !profileFallRef.current.contains(e.target)
            ) {
                setProfileFall(false);
            }
        };

        document.addEventListener("mousedown", onOutsideClick);
        return () => document.removeEventListener("mousedown", onOutsideClick);
    }, [profileFall]);

    const getProfileDp = () => {
        if (profile.data.profile_pic) {
            return (<img
                alt={profile.data.username}
                className={"top-nav-dp-holder"}
                src={profile.data.profile_pic}
            />);
        } else {
            return (
                <p className={"top-nav-dp-text-holder"}>{profile.data?.username ? profile.data?.username[0] : ""}</p>);
        }
    };

    return (<div className={"top-navigation-parent-container"}>
        <div className={"top-navigation-brand-container"}>
            <div
                className={"onlyMobile p-1 clickable"}
                onClick={() => {
                    if (mobileNavCallback != null) {
                        mobileNavCallback();
                    }
                }}
            >
                {mobileNavExpand ? (<div className={"wx-icons"}>close</div>) : (<div className={"wx-icons"}>menu</div>)}
            </div>
            <img
                src={brandLogo.pc}
                alt={`${brand?.app_name}-logo`}
                className={"top-navigation-brand-pc"}
            />
            <img
                src={brandLogo.mobile}
                alt={`${brand?.app_name}-logo`}
                className={"top-navigation-brand-mobile"}
            />
        </div>
        <div className="top-navigation-right-controls">
            <div className="top-nav-profile">
                <div className={"d-flex gap-1"}>
                    <div
                        className="refresh-holder"
                        onClick={() => {
                            sync();
                        }}
                    >
                        <Refresh className={syncCSS} />
                    </div>

                    <PrivilegeCheck allowed={TOP_NAV_VIEW_MODE_SWITCHER}>
                        <div className="shadow-lg d-flex">
                            <AccountSwitcher />
                        </div>
                    </PrivilegeCheck>

                    {/* Ref wraps toggle + dropdown so GridDots clicks are not treated as outside */}
                    <div
                        ref={profileFallRef}
                        className="d-flex top-nav-profile-container"
                        style={{
                            boxShadow: "none",
                            background: "transparent",
                            position: "relative",
                        }}
                    >
                        <div
                            className={"cursor-clickable d-flex align-items-center justify-content-center"}
                            style={{ width: 40, height: 40, borderRadius: '50%', transition: 'background-color 0.2s' }}
                            onClick={() => {
                                setProfileFall((old) => !old);
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(0,0,0,0.05)'}
                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                        >
                            <GridDotsIcon />
                        </div>
                        {profileFall && (
                            <div className="profile-dropdown shadow-wx-sm">
                    <div
                        className="profile-dropdown-item"
                        onClick={() => {
                            navigate(URL_PROFILE);
                            setProfileFall(false);
                        }}
                    >
                        <User /> <p className="ml-05">Profile</p>
                    </div>
                    <div
                        className={`profile-dropdown-item ${allowItems ? '' : 'disabled-calendar-action'}`}
                        onClick={() => {
                            if (allowItems) {
                                navigate(URL_INTEGRATION);
                                setProfileFall(false);
                            }
                        }}
                    >
                        <IntegrationIcon /> <p className="ml-05">Integration</p>
                    </div>
                    {!hidePricingOrg && <>
                    <PrivilegeCheck allowed={TOP_NAV_DROPDOWN_ORG_SUBSCRIPTION}>
                        {profile.data.userorgrolemapping &&
                            <div
                                className={`profile-dropdown-item ${allowItems ? '' : 'disabled-calendar-action'}`}
                                onClick={() => {
                                    if (allowItems) {
                                        navigate(URL_ORGANIZATION);
                                        setProfileFall(false);
                                    }
                                }}
                            >
                                <BuildingOffice strokeWidth={2.1} /> <p className="ml-05">Organization</p>
                            </div>
                        }

                        {/* {isEnterpriseAndOwner &&
                            <div
                                className={`profile-dropdown-item ${allowItems ? '' : 'disabled-calendar-action'}`}
                                onClick={() => {
                                    if (allowItems) {
                                        navigate(URL_ANALYTICS);
                                        setProfileFall(false);
                                    }
                                }}
                            >
                                <ArrowTrendingUpIcon/> <p className="ml-05">Analytics</p>
                            </div>
                        } */}


                        {isPrivateRouteEnabled("subscription") ? (
                        <div
                            className={`profile-dropdown-item ${allowItems ? '' : 'disabled-calendar-action'}`}
                            onClick={() => {
                                if (allowItems) {
                                    navigate(URL_SUBSCRIPTION);
                                    setProfileFall(false);
                                }
                            }}
                        >
                            <CreditCardIcon /> <p className="ml-05">Subscription</p>
                        </div>
                        ) : null}

                    </PrivilegeCheck>

                    <PrivilegeCheck allowed={TOP_NAV_DROPDOWN_CREDITS}>
                        <div
                            className={`profile-dropdown-item ${allowItems ? '' : 'disabled-calendar-action'}`}
                            onClick={() => {
                                if (allowItems) {
                                    navigate(URL_CREDITS);
                                    setProfileFall(false);
                                }
                            }}
                        >
                            <CoinsIcon /> <p className="ml-05">Credits</p>
                        </div>
                    </PrivilegeCheck>

                    {isPrivateRouteEnabled("pricing") ? (
                    <PrivilegeCheck allowed={[memberRole, adminRole, ownerRole]}>
                        <div
                            className={`profile-dropdown-item ${allowItems ? '' : 'disabled-calendar-action'}`}
                            onClick={() => {
                                if (allowItems) {
                                    navigate(URL_PRICING);
                                    setProfileFall(false);
                                }
                            }}
                        >
                            <Cash /> <p className="ml-05">Pricing</p>
                        </div>
                    </PrivilegeCheck>
                    ) : null}
                    </>}
                    <PrivilegeCheck allowed={TOP_NAV_DROPDOWN_ORG_SUBSCRIPTION}>
                        <div
                            className={`profile-dropdown-item ${allowItems ? '' : 'disabled-calendar-action'}`}
                            onClick={() => {
                                if (allowItems) {
                                    navigate(URL_ANALYTICS);
                                    setProfileFall(false);
                                }
                            }}
                        >
                            <ArrowTrendingUpIcon /> <p className="ml-05">Analytics</p>
                        </div>
                    </PrivilegeCheck>
                    
                     <PrivilegeCheck allowed={TOP_NAV_DROPDOWN_API_MANAGEMENT}>
                            <div
                                className={`profile-dropdown-item ${allowItems ? '' : 'disabled-calendar-action'}`}
                                onClick={() => {
                                    if (allowItems) {
                                        navigate(URL_API_MANAGEMENT);
                                        setProfileFall(false);
                                    }
                                }}
                            >
                                <CodeBracketIcon/> <p className="ml-05">Developers</p>
                            </div>
                        </PrivilegeCheck>
                         <PrivilegeCheck allowed={SUPPORT_PAGE}>
                            <div
                                className={`profile-dropdown-item ${allowItems ? '' : 'disabled-calendar-action'}`}
                                onClick={() => {
                                    if (allowItems) {
                                        navigate(URL_SUPPORT);
                                        setProfileFall(false);
                                    }
                                }}
                            >
                                <UserGroup strokeWidth={1.8}/> <p className="ml-05">Support</p>
                            </div>
                        </PrivilegeCheck>
                    <div className="profile-dropdown-item" onClick={() => Logout()}>
                        <LogoutIcon /> <p className="ml-05">Logout</p>
                    </div>
                            </div>
                        )}
                    </div>

                    <div className="shadow-lg pr-1 d-flex">
                        <AuthAccountSwitcher />
                    </div>
                </div>
            </div>
        </div>
    </div>);
}
